<template>
	<v-select
		v-model="currentValue"
		:items="currentOptions"
		outlined
		:item-text="(i) => `${i.name} (${i.code})`"
		item-value="code"
		:label="label || $t('port')"
		:disabled="!ready || disabled"
		:loading="!ready && !disabled"
		:clearable="clearable"
		clear-icon="icon-cross"
		append-icon="icon-angle-down"
		:rules="rules"
		:prepend-icon="prependIcon"
		@change="changeAction"
		:menu-props="{ offsetY: true }"
	/>
</template>

<script>
import remote from "../../data/remote";

export default {
	props: ["value", "options", "eager", "label", "clearable", "disabled", "rules", "prepend-icon"],
	data() {
		return {
			currentValue: null,
			currentOptions: [],
			ready: false,
		};
	},
	watch: {
		currentValue(val) {
			this.$emit("input", val);
		},
		value(val) {
			this.currentValue = val || null;
		},
		options(val) {
			this.handleProps();
		},
	},
	methods: {
		handleProps() {
			if (this.options) {
				this.handleOptions(this.options);
				this.ready = true;
			} else if (this.eager) this.loadOptions();
		},
		handleOptions(options) {
			this.currentOptions = options;
		},
		loadOptions() {
			remote.structures.getShippingTerms({
				onSuccess: (result) => {
					this.handleOptions(result.items);
					this.ready = true;
				},
			});
		},
		changeAction(code) {
			this.$emit(
				"change",
				this.currentOptions.find((i) => i.code === code)
			);
		},
	},
	created() {
		this.currentValue = this.value || null;
		this.handleProps();
	},
};
</script>
